import {
  List, Datagrid, TextField, DateField, EditButton, Edit, Create, SimpleForm,
  TextInput, SelectInput, DateInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const KINDS = [
  { id: 'term', name: 'Term' },
  { id: 'break', name: 'Break / holiday' },
  { id: 'exam', name: 'Exam' },
  { id: 'event', name: 'Event' },
];

const filters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <SelectInput key="kind" source="kind" choices={KINDS} alwaysOn />,
];

const CalendarList = () => (
  <List sort={{ field: 'startDate', order: 'ASC' }} filters={filters} perPage={50}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <DateField source="startDate" label="Start" />
      <DateField source="endDate" label="End" />
      <TextField source="kind" />
      <TextField source="title" />
      <EditButton />
    </Datagrid>
  </List>
);

const CalendarForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <SelectInput source="kind" choices={KINDS} validate={required()} sx={{ minWidth: 200 }} />
      <TextInput source="title" validate={required()} fullWidth />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <DateInput source="startDate" label="Start date" validate={required()} />
      <DateInput source="endDate" label="End date (optional)" />
    </Stack>
    <TextInput source="notes" multiline minRows={3} fullWidth />
    <NumberInput source="sortOrder" defaultValue={0} />
  </Stack>
);

const CalendarEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><CalendarForm /></SimpleForm>
  </Edit>
);
const CalendarCreate = () => (
  <Create redirect="list">
    <SimpleForm><CalendarForm /></SimpleForm>
  </Create>
);

export default {
  list: CalendarList,
  edit: CalendarEdit,
  create: CalendarCreate,
  icon: CalendarMonthIcon,
  options: { label: 'Academic calendar' },
  recordRepresentation: 'title',
};
